module.exports = __webpack_public_path__ + "img/download.80a61419.svg";